import { useContext, useEffect, useState } from "react";
import { useAccess } from "../../../../access/hooks/useAccess";
import { billingAllows } from "../../billingAccess";
import { SectionHeader } from "../../../ui";
import { Context } from "../../../../context/Context";
import { adminListAiWalletsAPI } from "../../../../utils/api/aiWallet";
import { useAiWalletText } from "../../aiWallet/aiWalletText";
import AiWalletAdminWallets from "../../aiWallet/admin/AiWalletAdminWallets";
import { AiWalletAdminCharges, AiWalletAdminPricing, AiWalletAdminReconciliation, AiWalletAdminTopUps } from "../../aiWallet/admin/AiWalletAdminViews";
import AiWalletAdminRollout from "../../aiWallet/admin/AiWalletAdminRollout";
import "../../aiWallet/AiWallet.css";

const VIEWS = ["wallets", "topUps", "charges", "rollout", "reconciliation", "pricing"];

// Finance/admin view of the AI Wallets. What each person may DO here
// (adjust, refund, price) comes from the billing access summary; the server
// checks every request again.
const AiWalletsTab = ({ access = null, onReviewPayments } = {}) => {
  const { lang = "en" } = useContext(Context) || {};
  const { can } = useAccess();
  const text = useAiWalletText(lang === "en" ? "en" : "ar");
  const t = text.admin;
  const canView = billingAllows(can("billing.admin.view"), access?.canAccessAdmin);
  const [view, setView] = useState("wallets");
  const [mode, setMode] = useState(null);

  useEffect(() => {
    if (!canView) return;
    adminListAiWalletsAPI({ limit: 1 })
      .then((result) => setMode(result.mode))
      .catch(() => {});
  }, [canView]);

  if (!canView) return <div className="billing-admin-denied">{t.denied}</div>;

  return (
    <section className="aiw-admin">
      <SectionHeader title={t.title} description={t.description} />
      <nav className="aiw-subnav" aria-label={t.title}>
        {VIEWS.filter((key) => key !== "rollout" || access?.canViewAiCost).map((key) => (
          <button key={key} type="button" className={`aiw-chip ${view === key ? "active" : ""}`} onClick={() => setView(key)}>
            {t.views[key]}
          </button>
        ))}
        {mode && (
          <span className={`aiw-mode ${mode === "enforce" ? "badge-success" : mode === "shadow" ? "badge-warning" : "badge-neutral"}`}>
            {t.mode}: {t.modes[mode] || mode}
          </span>
        )}
      </nav>
      {view === "wallets" && <AiWalletAdminWallets text={text} lang={lang} access={access} />}
      {view === "topUps" && <AiWalletAdminTopUps text={text} lang={lang} onReviewPayments={onReviewPayments} />}
      {view === "charges" && <AiWalletAdminCharges text={text} lang={lang} access={access} />}
      {view === "rollout" && <AiWalletAdminRollout text={text} lang={lang} />}
      {view === "reconciliation" && <AiWalletAdminReconciliation text={text} lang={lang} access={access} />}
      {view === "pricing" && <AiWalletAdminPricing text={text} lang={lang} access={access} />}
    </section>
  );
};

export default AiWalletsTab;
